import {
  GET_TRAINER_ERROR,
  GET_TRAINER_SUCCEED,
  UPDATE_TRAINER_SUCCEED,
  UPDATE_TRAINER_ERROR,
  GET_FOCUS_ARES_SUCCESS,
  TRAINING_LOADING_STATE,
  UPDATE_TRAINER_LAST_READ_NOTIFICATION_SUCCEEDED
} from './types';

const INITIAL_STATE = {
  trainer: {},
  loading: false
};

export default function(state = INITIAL_STATE, action) {
  if (action.type === GET_TRAINER_SUCCEED) {
    return { ...state, trainer: action.payload, loading: false };
  } else if (action.type === GET_TRAINER_ERROR) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === GET_FOCUS_ARES_SUCCESS) {
    return { ...state, focusAreas: action.payload };
  } else if (action.type === UPDATE_TRAINER_SUCCEED) {
    return { ...state, loading: false };
  } else if (action.type === UPDATE_TRAINER_LAST_READ_NOTIFICATION_SUCCEEDED) {
    return {
      ...state,
      trainer: { ...state.trainer, last_read_notification_date: action.payload }
    };
  } else if (action.type === UPDATE_TRAINER_ERROR) {
    return { ...state, error: action.payload, loading: false };
  } else if (action.type === TRAINING_LOADING_STATE) {
    return { ...state, loading: true };
  } else {
    return state;
  }
}
